export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/music_promotion.eb62f4c.svg";